import ModalAccounts from 'components/Modals/ModalAccounts';
import React from 'react';
import { Table } from 'reactstrap';

function AccountsTable(props) {
    const { items, url, updateState } = props;

    const rows = items.map((item) => (
        <tr key={item.id}>
            <th scope="row">{item.id}</th>
            <td>{item.name}</td>
            <td>
                <div style={{ width: '110px' }}>
                    {/* Modal que trae la configuración al abrirse */}
                    <ModalAccounts
                        url={url}
                        buttonLabel="Edit"
                        item={item}
                        updateState={updateState}
                    />
                </div>
            </td>
        </tr>
    ));

    return (
        <Table responsive hover>
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>{rows}</tbody>
        </Table>
    );
}

export default AccountsTable;
